import React from 'react'
import PropTypes from 'prop-types'

import Typography from '@eig-builder/core-ui/Typography'

import { getCurrencySymbol } from '@eig-builder/core-utils/helpers/currency-helper'

import TimeFormat from '../../../helpers/time-format'

import Text from '@eig-builder/module-localization'

const BottomRowInfo = ({ account, goodwillCredits }) => {
  return (
    <>
      <div className='col-auto'>
        <Typography variant='h4'>
          <Text message='modules.crm.components.account.created' />
        </Typography>
        <div className='mt-2'>
          <Typography variant='body2'>
            <TimeFormat date={account.created} />
          </Typography>
        </div>
      </div>
      {account.lastLogin && <div className='col-auto'>
        <Typography variant='h4'>
          Last login
        </Typography>
        <div className='mt-2'>
          <Typography variant='body2'>
            <TimeFormat date={account.lastLogin.created} />
          </Typography>
        </div>
      </div>}
      <div className='col-auto'>
        <Typography variant='h4'>
          <Text message='modules.crm.components.account.accountId' />
        </Typography>
        <div className='mt-2'>
          <Typography variant='body2'>{account.id}</Typography>
        </div>
      </div>
      <div className='col-auto'>
        <Typography variant='h4'>
          <Text message='modules.crm.components.account.billingId' />
        </Typography>
        <div className='mt-2'>
          <Typography variant='body2'>{account.uberClientId !== null ? account.uberClientId : '-'}</Typography>
        </div>
      </div>
      {account.creditCardLast4Digits && (
        <div className='col-auto'>
          <Typography variant='h4'>
            <Text message='modules.crm.components.account.last4Digits' />
          </Typography>
          <div className='mt-2'>
            <Typography variant='body2'>{account.creditCardLast4Digits}</Typography>
          </div>
        </div>
      )}
      {account.paypalBillingAgreementId && (
        <div className='col-auto'>
          <Typography variant='h4'>
            Paypal Billing Agreement Id
          </Typography>
          <div className='mt-2'>
            <Typography variant='body2'>{account.paypalBillingAgreementId}</Typography>
          </div>
        </div>
      )}
      {goodwillCredits > 0 && (
        <div className='col-auto'>
          <Typography variant='h4'>
            <Text message='modules.crm.components.account.credits' />
          </Typography>
          <div className='mt-2'>
            <Typography variant='body2'>
              {getCurrencySymbol(account.currencyCode)} {goodwillCredits.toFixed(2)}
            </Typography>
          </div>
        </div>
      )}
    </>
  )
}

BottomRowInfo.propTypes = {
  account: PropTypes.object.isRequired,
  goodwillCredits: PropTypes.number
}

export default BottomRowInfo
